import { IconChevronDown } from "@tabler/icons-react";
import { FAQ_ITEMS } from "./faqData.jsx";
import styles from "./Support.module.css";

export default function FaqList({ openId, onToggle, onContactClick }) {
  return (
    <div>
      <div className={styles.sectionHead}>
        <span className={styles.sectionHeadTitle}>
          Frequently Asked Questions
        </span>
        <span className={styles.sectionHeadBadge}>
          {FAQ_ITEMS.length} articles
        </span>
      </div>
      <div className={styles.faqList}>
        {FAQ_ITEMS.map((item) => {
          const isOpen = openId === item.id;
          return (
            <div
              key={item.id}
              className={`${styles.faqItem} ${isOpen ? styles.faqItemOpen : ""}`}
            >
              <button
                className={styles.faqQuestion}
                onClick={() => onToggle(item.id)}
              >
                <div className={styles.faqQLeft}>
                  <span className={styles.faqNum}>{item.id}</span>
                  <span className={styles.faqQText}>{item.question}</span>
                </div>
                <IconChevronDown className={styles.faqChevron} size={18} />
              </button>
              <div className={styles.faqAnswer}>
                <div className={styles.faqAnswerInner}>
                  {item.answer}
                  {item.hasContactLink && (
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        onContactClick();
                      }}
                    >
                      contacting support
                    </a>
                  )}
                  {item.hasContactLink && "."}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
